import React from 'react'
import { useSelector } from 'react-redux'

import { makeSelectIsLogged } from '../../../containers/MainLayout/selectors'
import FavoriteIcon from './FavoriteIcon'
import { Title } from './styles/Title'
import { TitleWrapper } from './styles/TitleWrapper'

interface Props {
  isFavorite: boolean
  slug: string
  name: string
}

export default function TitleWithFavoriteIcon({ isFavorite, slug, name }: Props) {
  const isLogged = useSelector(makeSelectIsLogged())

  return (
    <TitleWrapper>
      <Title>{name}</Title>
      <FavoriteIcon
        isFavorite={isFavorite}
        slug={slug}
        condition={!!isLogged}
      />
    </TitleWrapper>
  )
}
